import { render, staticRenderFns } from "./timelineSimple.vue?vue&type=template&id=963a97fa&"
import script from "./timelineSimple.vue?vue&type=script&lang=js&"
export * from "./timelineSimple.vue?vue&type=script&lang=js&"
import style0 from "./timelineSimple.vue?vue&type=style&index=0&id=963a97fa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports